import * as React from 'react';
import { ReferenceFilter as ReferenceFilterBase } from 'pages/Shipments/components/ReferenceFilter';
import { fetchWatchlistCustomers, QueryKeys } from 'services/clients/customers';
import { useQuery } from '@tanstack/react-query';
import { useFilterSearchParams, useWatchlistFilters } from '../../../utilities';

export const ReferenceFilter: React.FC = () => {
  const { searchParams, setSearchParams } = useFilterSearchParams(true);
  const [search, setSearch] = React.useState('');

  const filters = useWatchlistFilters();

  const query = useQuery({
    queryKey: [QueryKeys.WATCHLIST_CUSTOMERS, filters, search],
    queryFn: ({ signal }) => fetchWatchlistCustomers(filters, search, signal),
    keepPreviousData: true,
  });

  return (
    <ReferenceFilterBase
      references={query.data}
      isFetching={query.isFetching}
      selection={searchParams.customers}
      setSelection={(customers) => {
        setSearchParams({ customers });
      }}
      search={search}
      setSearch={setSearch}
    />
  );
};
ReferenceFilter.displayName = 'Shipments.Filters.ReferenceFilter';
